import {Pipe} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'hkdatetime',
  standalone:true,
})
export class HKDateTimePipe extends DatePipe {

  // @ts-ignore
  override transform(value: Date | string | number, format?: string): any {
    if (!format) {
      format = 'd MMMM, y, h:mm:ss a';
    }
    return super.transform(value, format, 'UTC+8');
  }

}

@Pipe({
  name: 'hkdate',
  standalone:true,
})
export class HKDatePipe extends DatePipe {

  // @ts-ignore
  override transform(value: Date | string | number, format?: string): any {
    if (!format) {
      format = 'd MMMM, y';
    }
    return super.transform(value, format, 'UTC+8');
  }

}
